/**
 * A practice's status in the operator's language, for every screen that shows one (HQ
 * Customers' Practice block, Tenant 360's header). One label set, `hc.tenantStatus.*`.
 *
 * `DETACH_STATUSES`: what a customer row's `tenant_status` says once it has lost its practice
 * (platform_customers.DETACH_REASONS): `tenant_id` is gone, and the status records how the
 * practice went.
 * `LABELLED_TENANT_STATUSES`: every `tenants.status` a writer stores
 * (super_admin_routes.TENANT_STATUSES: `past_due` is dunning, `churned` only a legacy row the
 * boot migration has not rewritten yet), then the detach reasons.
 * HqCustomers.tenantStatus.test.js reads both backend lists.
 */
export const DETACH_STATUSES = ["expired", "deleted", "relinked"];
export const LABELLED_TENANT_STATUSES = ["pending", "active", "past_due", "suspended", "cancelled", "churned", ...DETACH_STATUSES];

/** The label of `status`; a value with no label is shown as stored, and none as "—". */
export function tenantStatusLabel(t, status) {
  if (!status) return "—";
  return LABELLED_TENANT_STATUSES.includes(status) ? t(`hc.tenantStatus.${status}`) : status;
}
